import React from 'react';

const ProductQA = () => {
  return (
    <>
      <div className="w-full flex" />
    </>
  );
};

export default ProductQA;
